module.exports = __webpack_public_path__ + "static/media/amex.0c0ccf81.svg";